import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-image-collage',
  templateUrl: './image-collage.component.html',
  styleUrls: ['./image-collage.component.scss']
})
export class ImageCollageComponent {
  @Output() showCarousel = new EventEmitter<number>();

  images = [
    { src: '1.webp', alt: 'city tour street' },
    { src: '2.webp', alt: 'farm and countryside horses' },
    { src: '3.webp', alt: 'iguazu waterfall' },
    { src: '4.webp', alt: 'la ventana show' },
    { src: '5.webp', alt: 'montevideo at night' },
    { src: '6.webp', alt: 'rojo tango show' },
    { src: '7.webp', alt: 'wine urban art street art' },
    { src: '8.webp', alt: 'city colon streets' },
    { src: '9.webp', alt: 'city colon tour' },
    { src: '10.webp', alt: 'floralis generica' },
    { src: '11.webp', alt: 'tigre boat on water' },
    { src: '12.webp', alt: 'wine urban art tour' }
  ];
    
  basePath = '../../../../assets/imgs/collage/';

  clickOn(nImg: number) {
    this.showCarousel.emit(nImg);
  }

  trackByFn(index: number, item: { src: string }) {
    return item.src;
  }
}